import React, { useEffect, useState } from "react";
import Axios from "axios";
import { GetCandidateEvaluations } from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import { Button, Table, Card } from "react-bootstrap";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import nodataimg from "../assets/images/Nodata.jpg";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal";
import ReactPaginate from "react-paginate";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const safeParse = (str) => {
  if (!str) return {};
  try {
    const parsed = JSON.parse(str);

    // Case 1: The entire JSON is just a direct object
    if (!parsed) return {};

    // Case 2: If it’s wrapped in { evaluations: [...] }
    if (parsed.evaluations && Array.isArray(parsed.evaluations)) {
      return parsed.evaluations[0] || {};
    }

    // Case 3: If it’s an array directly
    if (Array.isArray(parsed)) {
      return parsed[0] || {};
    }

    return parsed;
  } catch (err) {
    console.error("Error parsing evaluation JSON:", err);
    return {};
  }
};


const ViewEvaluationResults = () => {
  let query = useQuery();
  const jobPost = query.get("jobPost");
  const location = useLocation();
  const { jobTitle, clientName, companyName } = location.state || {};
  const [evaluations, setEvaluations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [viewType, setViewType] = useState("list"); // default list view
    const [showIcon, setShowIcon] = useState('list');
const [showModal, setShowModal] = useState(false);
const [selectedCandidate, setSelectedCandidate] = useState(null);
const [candidateDetails, setCandidateDetails] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const itemsPerPage = 25; 
const [searchTerm, setSearchTerm] = useState("");
const token = localStorage.getItem("jwtToken");
const handlePageClick = ({ selected }) => {
  setCurrentPage(selected);
};

 const handleViewToggle = (type) => {
        setViewType(type);
        setShowIcon(type)
      };
const fetchCandidateDetails = async (candidatesID) => {
  setIsLoading(true);
  try {
     const res = await Axios.get(
      `${GetCandidateEvaluations.APIURL}?JobPostID=${jobPost}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const data = res.data || [];
    if (data.length > 0) {
      const latest = data
        .map(item => ({
          ...item,
          evaluationJson: safeParse(item.evaluationJson),
        }))
        .sort((a, b) => new Date(b.evaluationDate) - new Date(a.evaluationDate))[0];
      setCandidateDetails(latest);
    } else {
      setCandidateDetails(null);
    }
    setShowModal(true);
  } catch (err) {
    console.error("Error fetching candidate details:", err);
  }
  setIsLoading(false);
};

  const GetCandidateDetails = async () => {
    setIsLoading(true);
    try {
      const res = await Axios.get(
      `${GetCandidateEvaluations.APIURL}?JobPostID=${jobPost}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
      const data = res.data || [];
      const parsedData = data.map((item) => ({
        ...item,
        evaluationJson: safeParse(item.evaluationJson),
      }));
      setEvaluations(parsedData);
    } catch (err) {
      console.error("Error fetching candidate details:", err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    GetCandidateDetails();
  }, []);

const filteredEvaluations = evaluations.filter((ev) =>
  [ev.fullName, ev.email].some((field) =>
    field?.toLowerCase().includes(searchTerm.toLowerCase())
  )
);

// Pagination based on filtered list
const offset = currentPage * itemsPerPage;
const currentItems = filteredEvaluations.slice(offset, offset + itemsPerPage);
const pageCount = Math.ceil(filteredEvaluations.length / itemsPerPage);


  return (
    <ConsultantLayout>
       
      <div className="container-fluid mt-3">
      <div
  className="responsive-container"
  style={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}
>
  {/* Left side: arrow + heading */}
  <div style={{ display: "flex", alignItems: "center" }}>
    <Link to="/Employer/ListOfJobPosts">
      <i  className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: 10 }}
        aria-hidden="true" ></i>
    </Link>
    <h2 style={{ color: "#00a7ac", margin: 0 }}>Evaluation Results</h2>
  </div>

 <div
  className="responsive-container"
  style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
>
  {/* Left side: arrow + heading + search */}
  <div style={{ display: "flex", alignItems: "center" }}>
      {/* 🔍 Search input */}
    <input
      type="text"
              className="form-control"
      placeholder="Search by Name or Email"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0); // Reset to first page when searching
      }}
      style={{
        padding: "0 10px",
        border: "1px solid #ccc",
        height:40,
        borderRadius: 6,
        minWidth: 300,
        marginRight:10
      }}
    />
  </div>

  {/* Right side: view toggle icons */}
  <div style={{ display: "flex", alignItems: "center" }}>
    {showIcon === "grid" && (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
        <button
          className="btn btn-primary"
          onClick={() => handleViewToggle("list")}
          style={{
            backgroundColor: "#00a7ac",
            height: 38,
            width: 38,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <i className="fa fa-th-list" style={{ color: "#fff", fontSize: 16 }}></i>
        </button>
      </OverlayTrigger>
    )}

    {showIcon === "list" && (
      <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
        <button
          className="btn btn-primary"
          onClick={() => handleViewToggle("grid")}
          style={{
            backgroundColor: "#00a7ac",
            height: 38,
            width: 38,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <i className="fa fa-th" style={{ color: "#fff", fontSize: 16 }}></i>
        </button>
      </OverlayTrigger>
    )}
  </div>
</div>

</div>


        <hr />
      
        {isLoading ? (
          <center>
            <LoadingSpinner />
          </center>
        ) : filteredEvaluations.length === 0 ? (
          <div style={{ textAlign: "center" }}>
            <img
              src={nodataimg}
              alt="No Data"
              style={{ width: "100%", maxWidth: "500px" }}
            />
          </div>
        ) : 
        viewType === "list" ? (
       // Table View
         <>
                <div style={{ textAlign: "center", margin: "10px 0" }}>
                  <h5 style={{ color: "#00a7ac", marginBottom: "0" }}>
                    Evaluation Results for {jobTitle} – {clientName} - {companyName}
                  </h5>
                </div><table className="table mt-3"
                  style={{ minWidth: "100%", fontSize: "12px", tableLayout: "fixed", wordWrap: "break-word", }}>
                  <thead style={{ background: "#f8f9fa" }}>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Job Title</th>
                      <th>Client Name - Company Name</th>
                      <th>Skill - Role - Experience Match Scores</th>
                      {/* <th>Role Match Score</th>
     <th>Experience Match Score</th> */}
                      <th>Evaluated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((ev, idx) => (
                      <tr key={idx}>
                        <td>{ev.fullName}</td>
                        <td>{ev.email}</td>
                        <td>{ev.mobileNumber}</td>
                        <td>{ev.jobTitle}</td>
                        <td>{ev.vendorName} - {ev.vendorCompanyName}</td>
                        <td>{ev.evaluationJson.fitMatchScore ?? "N/A"} - {ev.evaluationJson.jobTitleMatchScore ?? "N/A"} - {ev.evaluationJson.experienceMatchScore ?? "N/A"}</td>
                        {/* <td>{ev.evaluationJson.jobTitleMatchScore ?? "N/A"}</td>
            <td>{ev.evaluationJson.experienceMatchScore ?? "N/A"}</td> */}
                        <td>{ev.evaluationDate?.split('T')[0]}</td>
                        <td>
                          <OverlayTrigger placement="bottom" overlay={<Tooltip>View Evaluation Result</Tooltip>}>
                            <button
                              style={{ background: "none", border: "none" }}
                              onClick={() => {
                                setCandidateDetails(ev); // set the clicked candidate
                                setShowModal(true); // open modal
                              } }
                            >
                              <i className="fa fa-eye mt-1" aria-hidden="true"
                                style={{ fontSize: 14, color: "#00a7ac" }}></i>
                            </button>


                          </OverlayTrigger>
                          <Link
                            to={`/Employer/EvaluationEachViewCandidateDetailsByCandidateGUid?guid=${ev.guid}&jobpost=${jobPost}`}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip>View Candidate Details</Tooltip>}
                            >
                              <button
                                style={{
                                  background: "none",
                                  border: "none",
                                  marginLeft: 8, // spacing between icons
                                }}
                              >
                                <i
                                  className="fa fa-user"
                                  aria-hidden="true"
                                  style={{ fontSize: 16, color: "#00a7ac" }}
                                ></i>
                              </button>
                            </OverlayTrigger>
                          </Link>

                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table></>

          
        ) : (
          // Grid View
          <div className="row">
            {currentItems.map((ev, idx) => (
                           <div className="col-md-6 col-lg-4 mb-3 mt-3" key={idx}>

              <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', borderRadius: 20, height: 330 }}>
                
                  <div className='card-body' style={{ height: 350 }}>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="positions-tooltip" {...props}>Name</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-user" aria-hidden="true"></i>  {ev.fullName}
                      </p>
                    </OverlayTrigger>

                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Email</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i>
                        {ev.email} 

                      </p>
                    </OverlayTrigger>
                       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Mobile Number</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i>
                        {ev.mobileNumber} 

                      </p>
                    </OverlayTrigger>
                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Role - Skill - Experience Match Scores</Tooltip>)}>
                      <p style={{ fontSize: 14 }}>
                        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-signal" aria-hidden="true"></i>
        {ev.evaluationJson.fitMatchScore ?? "N/A"} - {ev.evaluationJson.jobTitleMatchScore ?? "N/A"} - {ev.evaluationJson.experienceMatchScore ?? "N/A"}
                      </p>
                    </OverlayTrigger>
                               {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Role Match Score</Tooltip>)}>
                                          <p style={{ fontSize: 14 }}>
                                            <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-signal" aria-hidden="true"></i>
                                            {ev.evaluationJson?.jobTitleMatchScore} 
                    
                                          </p>
                                        </OverlayTrigger>
                                           <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="location-tooltip" {...props}>Experience Match Score</Tooltip>)}>
                                          <p style={{ fontSize: 14 }}>
                                            <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-signal" aria-hidden="true"></i>
                                            {ev.evaluationJson?.experienceMatchScore} 
                    
                                          </p>
                                        </OverlayTrigger> */}
                         
      </div>
                     <div className='card-footer d-flex justify-content-between'>

                        <OverlayTrigger
                          placement="bottom"
                          overlay={(props) => (
                            <Tooltip id="tooltip" {...props}>
                              View Evaluation Result
                            </Tooltip>
                          )}
                        >
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                             onClick={() => {
    setCandidateDetails(ev); // set the clicked candidate
    setShowModal(true);      // open modal
  }}
                          >
                            <i
                              className="fa fa-eye mt-1"
                              aria-hidden="true"
                              style={{ fontSize: 14, color: "#00a7ac" }}
                            ></i>
                          </button>
                        </OverlayTrigger>
                      <Link
                        to={`/Employer/EvaluationEachViewCandidateDetailsByCandidateGUid?guid=${ev.guid}&jobpost=${jobPost}`}
                      >
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip>View Candidate Details</Tooltip>}
                        >
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              marginLeft: 8, // spacing between icons
                            }}
                          >
                            <i
                              className="fa fa-user"
                              aria-hidden="true"
                              style={{ fontSize: 16, color: "#00a7ac" }}
                            ></i>
                          </button>
                        </OverlayTrigger>
                      </Link>
                  </div>
                  
                </div>
                </div>
            ))}
          </div>
        )}
      </div>
      <Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  size="lg"
  centered
  scrollable
>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#00a7ac" }}>Evaluation Result</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {isLoading ? (
      <center><LoadingSpinner /></center>
    ) : candidateDetails ? (
      <div style={{ padding: "10px",fontSize:14 }}>
        {/* --- Left Column --- */}
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div style={{ width: "30%", paddingRight: "20px", borderRight: "1px solid #ddd" }}>
            <p><strong>Name:</strong> {candidateDetails.fullName || "N/A"}</p>
            <p><strong>Email:</strong> {candidateDetails.email || "N/A"}</p>
            <p>
              <strong>Mobile:</strong> {candidateDetails.mobileNumber || "N/A"}
              {candidateDetails.mobileNumber && (
                <a href={`tel:${candidateDetails.mobileNumber}`} style={{ marginLeft: 10, color: "#00a7ac" }}>
                  <i className="fas fa-phone"></i>
                </a>
              )}
            </p>
            {/* Certifications */}
            {candidateDetails.certifications ? (
              <>
                <hr />
                <p>
                  <strong>🎓 Certifications:</strong>
                  <ul>
                    {candidateDetails.certifications.split(",").map((c, i) => (
                      <li key={i}>{c.trim()}</li>
                    ))}
                  </ul>
                </p>
                <hr/>
              </>
            ) : (
              <p><strong>🎓 Certifications:</strong> N/A</p>
            )}
           {candidateDetails.evaluationJson?.skillGaps?.length ? (
  <>
    <p style={{ fontSize: 16, marginBottom: 6 }}>
      <strong style={{ color: "#00a7ac" }}>Skill Gaps:</strong>
    </p>
    <div style={{ fontSize: 14 }}>
      {candidateDetails.evaluationJson.skillGaps.map((item, idx) => (
        <div key={idx}>
          {item["JD Skill"]}: {item.Match}
        </div>
      ))}
    </div> 
    <hr />
  <div style={{ fontSize: 12, marginBottom: 6 }}>
      <span style={{ marginRight: 15 }}>✅ Full Match</span>
      <span style={{ marginRight: 15 }}>🔶 Partial Match</span><br/>
      <span>❌ Skills Missing</span>
    </div>
    <hr />
  </>
) : (
  <p><strong>Skill Gaps:</strong> N/A</p>
)}


          </div>
 

          {/* --- Right Column --- */}
          <div style={{ width: "70%", paddingLeft: "20px" }}>
            <p>
              <strong style={{ color: "#00a7ac" }}>📈 Skill - Role - Experience Match Scores:</strong>{" "}
              {candidateDetails.evaluationJson?.fitMatchScore ?? "N/A"} -  {candidateDetails.evaluationJson?.jobTitleMatchScore ?? "N/A"} - {candidateDetails.evaluationJson?.experienceMatchScore ?? "N/A"} 
            </p>
               {/* <p>
              <strong style={{ color: "#00a7ac" }}>📈 Role Match Score:</strong>{" "}
              {candidateDetails.evaluationJson?.jobTitleMatchScore ?? "N/A"}%
            </p>
              <p>
              <strong style={{ color: "#00a7ac" }}>📈 Experience Match Score:</strong>{" "}
              {candidateDetails.evaluationJson?.experienceMatchScore ?? "N/A"}%
            </p> */}
            <hr />
            <p>
              <strong style={{ color: "#00a7ac" }}>High-Level Fit Summary:</strong>
              <br />
              {candidateDetails.evaluationJson?.overallSummary || "N/A"}
            </p>
            <hr />
            <>
  <p style={{ fontSize: 16 }}>
    <strong style={{ color: "#00a7ac" }}>
      📌 JD Skills Matched in Recent Projects:
    </strong>
  </p>

  {candidateDetails?.evaluationJson?.matchedSkillsInRecentProjects?.length > 0 ? (
    <ul>
      {candidateDetails?.evaluationJson?.matchedSkillsInRecentProjects.map((item, idx) => (
       <li key={idx}>
  ✅ <strong>{item["JD Skill"]}</strong> — {item["Found in Project"]}
</li>
      ))}
    </ul>
  ) : (
    <p style={{ fontSize: 16, color: "gray", marginLeft: 10 }}>
      No matched JD skills found in recent projects.
    </p>
  )}
  <hr />
</>
            <p>
              <strong style={{ color: "#00a7ac" }}>💡 Improvement Insights:</strong>
              {candidateDetails.evaluationJson?.improvementInsights?.length ? (
                <ul>
                  {candidateDetails.evaluationJson.improvementInsights.map((ins, i) => (
                    <li key={i}>{ins}</li>
                  ))}
                </ul>
              ) : (
                " N/A"
              )}
            </p>
          </div>
        </div>
      </div>
    ) : (
      <div style={{ textAlign: "center" }}>
        <img src={nodataimg} alt="No Data" style={{ width: "100%", maxWidth: "300px" }} />
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
  </Modal.Footer>
</Modal>
{filteredEvaluations.length > itemsPerPage && (
  <div className="d-flex justify-content-center mt-4">
    <ReactPaginate
      previousLabel={"Prev"}
      nextLabel={"Next"}
      breakLabel={"..."}
      breakClassName={"break-me"}
      pageCount={pageCount}
      marginPagesDisplayed={2}
      pageRangeDisplayed={5}
      onPageChange={handlePageClick}
      containerClassName={"pagination"}
      pageClassName={"page-item"}
      pageLinkClassName={"page-link"}
      previousClassName={"page-item"}
      nextClassName={"page-item"}
      previousLinkClassName={"page-link"}
      nextLinkClassName={"page-link"}
      activeClassName={"active"}
      disabledClassName={"disable-pagination-button"}
      forcePage={currentPage}  // keeps page in sync when filtering
    />
  </div>
)}

    </ConsultantLayout>
  );
};

export default ViewEvaluationResults;
